// THEME
export const THEME_REQUEST = 'THEME_REQUEST';
export const THEME_SUCCESS = 'THEME_SUCCESS';
export const THEME_ERROR = 'THEME_ERROR';
// Menu Configuration
export const MENU_CONFIGURATION_SUCCESS = 'MENU_CONFIGURATION_SUCCESS';
// EDIT MENU CONFIGURATION
export const EDIT_MENU_CONFIGURATION_SUCCESS = 'EDIT_MENU_CONFIGURATION_SUCCESS';
// MENU PRINT CONFIGURATION
export const MENU_PRINT_CONFIGURATION_REQUEST = 'MENU_PRINT_CONFIGURATION_REQUEST';
// EDIT THEME
export const EDIT_THEME_REQUEST = 'EDIT_THEME_REQUEST';
export const EDIT_THEME_SUCCESS = 'EDIT_THEME_SUCCESS';
export const EDIT_THEME_ERROR = 'EDIT_THEME_ERROR';

// MOMENT OF CONSUME
export const MOMENT_OF_CONSUME_LIST_REQUEST = 'MOMENT_OF_CONSUME_LIST_REQUEST';
export const MOMENT_OF_CONSUME_LIST_SUCCESS = 'MOMENT_OF_CONSUME_LIST_SUCCESS';
export const MOMENT_OF_CONSUME_LIST_ERROR = 'MOMENT_OF_CONSUME_LIST_ERROR';
// MENU SECTION TYPES
export const MENUSECTION_TYPES_SUCCESS = 'MENUSECTION_TYPES_SUCCESS';
// TEMPLATES
export const TEMPLATE_LIST_SUCCESS = 'TEMPLATE_LIST_SUCCESS';

export const MENU_FONTS_LIST_SUCCESS = 'MENU_FONTS_LIST_SUCCESS';
export const CREATE_MENU_FONTS_SUCCESS = 'CREATE_MENU_FONTS_SUCCESS';
export const DELETE_MENU_FONTS_SUCCESS = 'DELETE_MENU_FONTS_SUCCESS';

// MENU SECTION TYPES
export const PRINT_MENU_SECTION_REQUEST = 'PRINT_MENU_SECTION_REQUEST';

// MENU GRID CONFIGURATION
export const MENU_GRID_CONFIGURATION_SUCCESS = 'MENU_GRID_CONFIGURATION_SUCCESS';
